import { isDefined, joinStrings } from 'mmfintech-commons'
import { v4 as uuid } from 'uuid'

type UserNameType = {
  firstName?: string
  lastName?: string
}

const hasUserName = (value: unknown): value is UserNameType =>
  isDefined(value) && typeof value === 'object' && ('firstName' in value || 'lastName' in value)

export const extractInitials = (user: unknown, defaultResponse: string = 'O'): string => {
  // "O" is for the old owner users which do not have firstName and lastName

  if (hasUserName(user)) {
    const initials = joinStrings([user.firstName?.charAt(0).toUpperCase(), user.lastName?.charAt(0).toUpperCase()], '')
    if (initials) return initials
  }
  return defaultResponse
}

export const preparedTooltip = (users: any) => {
  return `
  ${users
    ?.map((user: any) => {
      const { customerRole, firstName, lastName } = user || {}

      return `<div key={${uuid()}}>
        ${customerRole ? `<span>${customerRole}</span>` : ''}
        <h6>
          ${firstName || ''} ${lastName || ''}
        </h6>
      </div>`
    })
    .join('')}
`
}
